import { render, staticRenderFns } from "./aboutteam.vue?vue&type=template&id=c1cf9fc4&"
import script from "./aboutteam.vue?vue&type=script&lang=js&"
export * from "./aboutteam.vue?vue&type=script&lang=js&"
import style0 from "./aboutteam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports